import React, { FC, useState, useEffect } from 'react'
import styles from 'styles/components/template.module.scss'
import { State } from 'index'
import { db } from 'firebase/index'
import { useDispatch, useSelector } from 'react-redux'
import QRCode from 'qrcode.react'
import { push } from 'connected-react-router'
import { GreyButton } from 'components/Button'
import { Description } from 'components/Typography'
import { Spacer } from 'components/Utility'
import { getPointCard } from 'reducks/pointCard/selectors'
import { FlexRow } from 'components/Flex'
import { fetchPointCardCodeForInStore } from 'repos/pointCard/pointCardCode'
import { getStoreRef } from 'reducks/auth/selectors'

const PointCardCodeInStoreTemplate: FC = () => {
  const dispatch = useDispatch()
  const pointCard = useSelector((state: State) => getPointCard(state))
  const storeRef = useSelector((state: State) => getStoreRef(state))
  const [code, setCode] = useState<string>('')

  useEffect(() => {
    ;(async () => {
      if (!pointCard) return
      const pointCardCode = await fetchPointCardCodeForInStore(pointCard.ref.id)
      if (!pointCardCode) return
      setCode(pointCardCode.code)
    })()
  }, [pointCard])

  return (
    <div className={styles.standard}>
      <Spacer size={40} />
      <Description
        description={
          '端末のカメラもしくは、sacriのポイントカードのQRコードリーダーから下記のQRコードを読み取ってください。'
        }
      />
      <Spacer size={12} />
      <FlexRow justifyContent={'center'}>
        <QRCode id={'qrcode'} size={343} value={`sacri://point-card/create?code=${code}&store_id=${storeRef.id}`} />
      </FlexRow>
      <Spacer size={40} />
      <GreyButton
        label={'ポイント付与QRコードに戻る'}
        onClick={() => dispatch(push('/point_card/code'))}
        size={'medium'}
        type={'outlined'}
      />
      <Spacer size={40} />
    </div>
  )
}

export default PointCardCodeInStoreTemplate
